import React from "react"
import s from "./ProgressBar.module.scss"
import cx from "classnames"
import EventPubSub from "scripts/util/EventPubSub"

import Border from "assets/images/progressbar.png"
// import Icon from 'assets/images/game-character-icon-fpo.png'
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { useState } from "react"
import store from 'store'
import {setState} from 'store/game'

ProgressBar.defaultProps = {}

export default function ProgressBar({ progress, className }) {
  const character = useSelector((state) => state.game.character)
  const [icon, setIcon] = useState("yeti")

  useEffect(() => {
    setIcon(require(`assets/images/icon-${character}.png`).default)
  }, [character])

  const handlePause = () => {
    store.dispatch(setState({paused: true}))
    EventPubSub.emit("pause")
  }

  return (
    <div
      className={cx(s.ProgressBar, className)}
    >
      <button
        className={s.pauseBtn}
        onClick={handlePause}
        aria-label="Pause"
      ></button>
      <div className={s.imageWrapper}>
        <img src={Border} alt="Progress Bar" />
        <div className={s.progressWrapper}>
          <div className={s.progress} style={{ width: `${progress * 100}%` }}>
            <img src={icon} className={s.icon} alt="Character portrait" />
          </div>
        </div>
      </div>
    </div>
  )
}
